// Radio-grid of stamp styles: default square, 8 pixel presets, and the
// shop's own pixelated logo when one exists. Controlled component.
import { StampGlyph, STAMP_PRESET_IDS } from '../dashboard/stamp-icons';

interface StampStylePickerProps {
  value: string;
  hasLogo: boolean;
  pixelImageUrl?: string;
  onChange: (icon: string) => void;
}

export default function StampStylePicker({ value, hasLogo, pixelImageUrl, onChange }: StampStylePickerProps) {
  const options: Array<{ id: string; label: string }> = [
    { id: 'default', label: 'default' },
    ...STAMP_PRESET_IDS.map(id => ({ id, label: id })),
    ...(hasLogo ? [{ id: 'logo', label: 'my logo' }] : []),
  ];

  return (
    <div role="radiogroup" aria-label="Stamp style" className="grid grid-cols-4 gap-[10px]">
      {options.map(opt => {
        const selected = value === opt.id;
        return (
          <button
            key={opt.id}
            role="radio"
            aria-checked={selected}
            aria-label={opt.label}
            onClick={() => onChange(opt.id)}
            className={`aspect-square rounded-[10px] border-[3px] flex items-center justify-center p-2 transition-colors ${
              selected ? 'border-coral bg-coral/10' : 'border-hairline bg-white hover:border-body-grey'
            }`}
          >
            {opt.id === 'default' && <div className="w-full h-full rounded-[4px] bg-coral" />}
            {opt.id === 'logo' && (
              <img src={pixelImageUrl} alt="shop logo stamp" className="w-full h-full object-contain" style={{ imageRendering: 'pixelated' }} />
            )}
            {opt.id !== 'default' && opt.id !== 'logo' && (
              <span className={`w-full h-full ${selected ? 'text-coral' : 'text-body-grey'}`}><StampGlyph icon={opt.id} className="w-full h-full" /></span>
            )}
          </button>
        );
      })}
    </div>
  );
}
